import { MapService } from './../../utils/map.service';
import { DataManagementService } from './../../providers/data-management.service';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController,LoadingController,ViewController,Events } from 'ionic-angular';
import {DatePipe} from '@angular/common';
import {Mileage} from '../../objects/real-time'

 @Component({
  selector: 'page-mileage-list',
  templateUrl: 'mileage.html',
})
export class MileageComponent {
    mileages:Mileage;
    MileageArray = [];
    totalMileage: Mileage;
    kilo : any;
    
    constructor(public navCtrl: NavController,
        private datamanagementService : DataManagementService,
        private mapService:MapService,
         public navParams: NavParams,
          public viewCtrl: ViewController,
          private modalCtrl:ModalController,
          public events : Events) {
       // this.mileages = navParams.get('mileages');
        //this.totalMileage = navParams.get('totalMileage');
          this.events.subscribe('listPathKilo', (mileages) => {
          this.mileages = mileages;
        });
           this.events.subscribe('listPathKilo1', (totalMileage) => {
          this.totalMileage = totalMileage;
        });

           this.callPathlist();
            console.log(this.mileages);
            this.callPath1list();
            console.log(this.totalMileage);



       events.subscribe('kilo', () => {
    this.publishKilo();
});




        }

        callPathlist(){
        this.events.publish("kiloList");
        }

        callPath1list(){
        this.events.publish("kiloList1");
        }



seeOnMap(kilo){
  this.kilo = kilo;
 this.events.publish("changeToMapKilo",true);
     // this.navCtrl.setRoot(LeafletmapPage,{path: path});
}

publishKilo(){
  this.events.publish("selectedKilo",this.kilo);
}






    addMileageToArray(mileage: any, event) {
        if (!event.ctrlKey) {
            this.MileageArray = [];
            this.mapService.removePolylinesFromMap();
            this.mapService.removeMarkersFromMap();
        }

        this.MileageArray.push(mileage);
        this.viewCtrl.dismiss(mileage);
    }

    closeModal(){
        this.viewCtrl.dismiss(1); 
    }

    returnModal(){
        this.viewCtrl.dismiss(null); 
    }
    
}



// WEBPACK FOOTER //
// ./src/pages/mileage/mileage.ts